
import { NavLink } from 'react-router-dom';
import { Inbox, Send, File, Trash2, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { useEmail } from '@/context/EmailContext';

interface EmailNavigationProps {
  onItemClick?: () => void;
}

const EmailNavigation = ({ onItemClick }: EmailNavigationProps) => {
  const { statistics } = useEmail();
  
  return (
    <div className="flex flex-wrap items-center gap-1">
      <NavLink 
        to="/app/email/inbox" 
        onClick={onItemClick}
        className={({ isActive }) =>
          cn(
            "flex items-center gap-1 rounded-md px-3 py-1 text-sm",
            "hover:bg-accent hover:text-accent-foreground",
            isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground"
          )
        }
      >
        {({ isActive }) => (
          <>
            <Inbox className="h-4 w-4" />
            <span className="hidden sm:inline">Inbox</span>
            {statistics.unread > 0 && (
              <Badge variant={isActive ? "secondary" : "default"} size="xs" className="rounded-full flex items-center justify-center p-0">
                {statistics.unread}
              </Badge>
            )}
          </>
        )}
      </NavLink>
      
      <NavLink 
        to="/app/email/sent" 
        onClick={onItemClick}
        className={({ isActive }) =>
          cn(
            "flex items-center gap-1 rounded-md px-3 py-1 text-sm",
            "hover:bg-accent hover:text-accent-foreground",
            isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground"
          )
        }
      >
        {({ isActive }) => (
          <>
            <Send className="h-4 w-4" />
            <span className="hidden sm:inline">Sent</span>
          </>
        )}
      </NavLink>
      
      <NavLink 
        to="/app/email/drafts" 
        onClick={onItemClick}
        className={({ isActive }) =>
          cn(
            "flex items-center gap-1 rounded-md px-3 py-1 text-sm",
            "hover:bg-accent hover:text-accent-foreground",
            isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground"
          )
        }
      >
        {({ isActive }) => (
          <>
            <File className="h-4 w-4" />
            <span className="hidden sm:inline">Drafts</span>
          </>
        )}
      </NavLink>
      
      <NavLink 
        to="/app/email/trash" 
        onClick={onItemClick}
        className={({ isActive }) =>
          cn(
            "flex items-center gap-1 rounded-md px-3 py-1 text-sm",
            "hover:bg-accent hover:text-accent-foreground",
            isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground"
          )
        }
      >
        {({ isActive }) => (
          <>
            <Trash2 className="h-4 w-4" />
            <span className="hidden sm:inline">Trash</span>
          </>
        )}
      </NavLink>
      
      <NavLink 
        to="/app/email/settings" 
        onClick={onItemClick}
        className={({ isActive }) =>
          cn(
            "flex items-center gap-1 rounded-md px-3 py-1 text-sm",
            "hover:bg-accent hover:text-accent-foreground",
            isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground"
          )
        }
      >
        <Settings className="h-4 w-4" />
        <span className="hidden sm:inline">Settings</span>
      </NavLink>
    </div>
  );
};

export default EmailNavigation;
